/**
 * @file Video Play Data
 */
import {
  durationFormatter,
  integerValueFormatter,
} from 'src/const/statistics/formatters';
import { isAdmin } from 'src/utils/authUtil';
import { isMRCWhite } from 'src/const/whiteList';

// 视频播放数据
export const EnumVideoPlayData = [
  {
    key: 'total_play',
    i18nPath: 'list_video_play_count', // 播放次数
    hint: 'campaign_hover_stat_data.total_play',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_duration_2s',
    i18nPath: 'list_video_play_duration_2s', // 播放2s
    hint: 'campaign_hover_stat_data.play_duration_2s',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'module_video_play_mrc_play_count', // 连续播放2s次数
    hint: 'campaign_hover_stat_data.mrc_play_count',
    key: 'mrc_play_count',
    hide: () => !isMRCWhite(), // 可见 mrc 指标的白名单
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_duration_6s',
    i18nPath: 'list_video_play_duration_6s', // 播放6s
    hint: 'campaign_hover_stat_data.play_duration_6s',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_over',
    i18nPath: 'module_video_play_complete', // 播放100%
    hint: 'module_video_play_complete_hint',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_third_quartile',
    i18nPath: 'module_video_play_third_quartile', // 播放75%
    hint: 'module_video_play_third_quartile_hint',
    hoverKey: 'module_video_play_third_quartile_hint',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_midpoint',
    i18nPath: 'module_video_play_midpoint', // 播放50%
    hint: 'module_video_play_midpoint_hint',
    hoverKey: 'module_video_play_midpoint_hint',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'play_first_quartile',
    i18nPath: 'module_video_play_first_quartile', // 播放25%
    hint: 'module_video_play_first_quartile_hint',
    hoverKey: 'module_video_play_first_quartile_hint',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    key: 'average_video_play',
    i18nPath: 'list_video_average_play_duration', // 平均视频播放时长
    hint: 'campaign_hover_stat_data.average_video_play',
    'min-width': 200,
    sortable: true,
    formatter: durationFormatter,
  },
  {
    key: 'average_video_play_per_user',
    i18nPath: 'list_video_average_video_play_per_user', // 平均每人播放时长
    hint: 'campaign_hover_stat_data.average_video_play_per_user',
    'min-width': 200,
    sortable: true,
    formatter: durationFormatter,
  },
];

export const EnumUVData = [
  {
    i18nPath: 'list_video_total_play_uv', // 播放人数
    hint: 'campaign_hover_stat_data.total_play_uv',
    key: 'total_play_uv',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'list_video_play_duration_6s_uv', // 播放6s UV
    hint: 'campaign_hover_stat_data.play_duration_6s_uv',
    key: 'play_duration_6s_uv',
    sortable: true,
    formatter: integerValueFormatter,
    hide: () => !isAdmin(),
  },
  {
    i18nPath: 'list_video_play_over_uv', // 播放完成UV
    hint: 'campaign_hover_stat_data.play_over_uv',
    key: 'play_over_uv',
    sortable: true,
    formatter: integerValueFormatter,
  },
];
